export const linkResolver = doc => {
  if (doc.type === 'generic_static_page') return `/${doc.uid}`;

  if (doc.type === 'about_us') return `/about-us`;
  if (doc.type === 'join_us') return `/join-us`;
  if (doc.type === '360gateway') return `/360-gateway`;
  if (doc.type === 'homepage') return `/`;

  return `/${doc.uid}`;
};
